import {
  connectFirestoreEmulator,
  Firestore,
  getFirestore,
} from 'firebase/firestore';

import { app } from './app';
import { getEmulatorHost, isEmulatorEnabled } from './emulator-config';

export const db: Firestore = getFirestore(app);

if (isEmulatorEnabled()) {
  connectFirestoreEmulator(db, getEmulatorHost(), 8081);
}
